// @flow
/* eslint-disable no-template-curly-in-string */

export default {
  All: 'All',
  AllDocuments: 'All documents',
  Any: 'Any',
  Today: 'Today',
  Yesterday: 'Yesterday',
  LastWeek: 'Last week',
  LastMonth: 'Last month',
  DateFrom: 'From',
  DateTo: 'To',
  DateRange: 'Date range',
  NeverViewed: 'Never viewed or changed since last viewed',
  AddedLastLogin: 'Added or changed since last login',
  GlobalNetworkErrorMessage:
    'There\u0027s a problem with the network. Try again or contact support.',
  GlobalIntermediateProxyErrorMessage:
    'Your network intercepted this request to the dataroom. Contact your IT department.',
  GlobalUnexpectedErrorWithIdMessage:
    'There\u0027s a problem with your dataroom.  Quote this code \u003c[ErrorId]\u003e to our Client Services team.',
  GlobalUnexpectedErrorMessage:
    'There\u0027s a problem with your dataroom.  Please contact our Client Services team.',
  NoRecordsFound: 'No records found.',
  Save: 'Save',
  Print: 'Print',
  ViewAs: 'View as',
  Documents: 'Documents',
  Date: 'Date',
  HideEmptyFolders: 'Hide empty folders',
  Search: 'Search',
  Actions: 'Actions',
  Filter: 'Filter',
  Self: 'You',
  Allowed: 'Allowed',
  Denied: 'Denied',
  PleaseEnterValidToDate: 'Please enter a valid to date.',
  PleaseEnterValidFromDate: 'Please enter a valid from date.',
  SavingAllowed: 'Saving allowed',
  SavingDenied: 'Saving denied',
  PrintingAllowed: 'Printing allowed',
  PrintingDenied: 'Printing denied',
  ChooseLanguage: 'Choose Language',
  EditProfile: 'Edit Profile',
  DataRooms: 'Data Rooms',
  Administration: 'Administration',
  MyAccount: 'MyAccount',
  Profile: 'Profile',
  Logout: 'Logout',
  Loading: 'Loading',
  Success: 'Success',
  Disabled: 'Disabled',
  Ok: 'Ok',
  And: 'and',
  Demo: 'Demo',
  TenderSubmissionsStart: 'Start submission process',
  TenderSubmissionsOverdue:
    'Submission process has ended. Documents you upload now will be marked as late.',
  TenderSubmissionsClose: 'Submission process has ended.',
  Later: 'Later',
  StartNow: 'Start now',
  StartSubmissionDialogTitle: 'Start submission process',
  StartSubmissionDialogContent:
    'Bidders will be notified that they can upload and view documents. ' +
    "Your internal teams can't access documents during the submission process.",
  StartSubmissionDialogCloseDateContent:
    'The submission process ends on ${closeDate}.',
  SubmissionInformationIsIncomplete: 'Submission information is incomplete. ',
  BidderTeamsHaveNotBeenInvitedOrHaveBeenRemoved:
    'Bidders have not been invited or have been removed. ',
  InviteBidderTeams: 'Invite bidders',
  UpdateSecuritySettings: 'Update security settings',
  UpdateTheirSecuritySettings: 'Update their security settings.',
  OnTimeSubmission: 'On time submission',
  LateSubmission: 'Late submission',
  DeleteAllDocuments: 'Delete all submission documents',
  Manage: 'Manage',
  ManageSubmissions: 'Manage submissions',
  NotStarted: 'Not Started',
  Closed: 'Closed',
  ExtraTime: 'In Extra Time',
  Open: 'Open',
  CreateTheStructureAndSetTheCloseDateForBidderSubmissions:
    'Create the structure and set the close date for bidder submissions.',
  AddSubmissionWindow: 'Add submission window',
  BiddersDoNotHaveAccessToAddSubmissionsSingular:
    '1 bidder do not have access to add submissions.',
  BiddersDoNotHaveAccessToAddSubmissionsPlural:
    '${totalBidders} bidders do not have access to add submissions.',
  BulkRedactionCurrentDocumentNumberOfTotal:
    '${currentDocumentNumber} of ${totalDocsCount} documents',
  BulkRedactionMarksToRedact: '${selectedMarksCount} items to redact',
  BulkRedactionMarksRedacted: '${redactionMarksCount} items redacted',
  BulkRedactionSkipAndNext: 'Skip document',
  BulkRedactionSkipAndFinish: 'Skip and finish redacting',
  BulkRedactionSaveAndNext: 'Save & next document',
  BulkRedactionSaveAndFinish: 'Save and finish redacting',
  BulkRedactionRedactAllRemainingDocuments:
    'Redact all ${documentsRemaining} documents',
  BulkRedactionCancel: 'Cancel',
  DocumentsOrFoldersFromWorkflowCannotBeMoved:
    'Documents or folders from workflow cannot be moved.',
  CannotAddItemIntoWorkflowFolder: 'You cannot add documents to this folder.',
  CannotDragAndMoveToThisFolder: 'You cannot drag and move to this folder.',
  MovedFromWorkflow: 'Moved from Workflow',
  ViewInWorkflow: 'View in Workflow',
};
